import { render, staticRenderFns } from "./integrationSettings.vue?vue&type=template&id=94d50ac8&scoped=true"
import script from "./integrationSettings.vue?vue&type=script&lang=js"
export * from "./integrationSettings.vue?vue&type=script&lang=js"
import style0 from "./integrationSettings.vue?vue&type=style&index=0&id=94d50ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d50ac8",
  null
  
)

export default component.exports